<template>
  <div>
    <header class="seedTwoHead">追溯网址</header>

    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <section v-else class="stBox">

			<div class="stTitle" v-if="datas.batch.name"><a>加工批次：</a><a v-text="datas.batch.name"></a></div>
			<div class="stTitle"><a><img src="/static/images/Normal19/icon_01.png"></a><a>品种信息</a></div>
			<div>
				<ul class="stMain">
					<li>品种名称：{{datas.product.name}}</li>
          <li v-for="(item, index) in datas.product.attribute" :key="index">
            {{ item.key }}：{{ item.value }}
          </li>
				</ul>
			</div>
			
			<!-- 公司信息  -->
			<div class="stTitle"><a><img src="/static/images/Normal19/icon_02.png"></a><a>生产经营者</a></div>
			<div>
				<ul class="stMain">
          <li v-for="(item, index) in datas.business.customize_data">{{item.key}}：{{item.value}}</li>
					<li>公司简介：{{datas.business.name}}</li>
				</ul>
			</div>
			
			<!-- 溯源信息 -->
			<div class="stTitle"><a><img src="/static/images/Normal19/icon_03.png"></a><a>销售信息</a></div>
			<div>
				<ul class="stMainTwo">
					<li><a>时间</a><a>发往</a></li>
					<li v-for="(item, index) in datas.dealer" v-bind:key="index"><a>{{item.date}}</a><a>{{item.name}}</a></li>
				</ul>
			</div>

      <div class="stCopyright">技术支持：<a href="http://oid.plus/">温州链接科技有限公司</a></div>
    </section>
  </div>
</template>

<script>
var self;
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'PesticideDetails',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data() {
    return {
      code: null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      datas: null
    }
  },
  created() {
    self = this;
    self.datas = JSON.parse(localStorage.getItem("wwm_seedDetail"));
    document.body.style.backgroundColor = "white";
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style scoped>
header {
  width: 100%;
  color: #fff;
  padding: 13px 0;
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  background-color: #317ef3;
}
/* 种子  */
.seedTwoHead{
    width: 100%;
    color: #fff;
    padding: 13px 0;
    font-size: 20px;
    text-align: center;
	background-color: #83c326;
}
.stBox{
	padding:0px 10px;
}
.stTitle{
	overflow: hidden;
	margin-top:20px;
}
.stTitle a{
	display: block;
	color:#83c326;
	float: left;
	font-size:17px;
	line-height:40px;
}
.stTitle img{
	display: block;
	width:35px;
	margin-right:5px;
}
.stMain{
	margin-top:5px;
	background-color: #e6f0e5;
	padding:0px 5px;
}
.stMain li{
	font-size:14px;
	padding:0px 5px;
	padding-bottom:10px;
	line-height:23px;
	overflow: hidden;
  word-break: break-all;
}
.stMain li a{
	display: block;
	float: left;
}
.stMain li:first-child{
	padding-top:10px;
}
.stMain li a:first-child{
	color:#444;
}
.stCopyright{
	font-size:12px;
	text-align: center;
	padding:20px 0;
}
.stCopyright a{
	color:#000;
	text-decoration: none;
}

.stMainTwo{
	margin-top:5px;
	background-color: #e6f0e5;
}
.stMainTwo li{
	overflow: hidden;
	color:#444;
	font-size:13px;
	border-bottom:1px solid #dceada;
}
.stMainTwo li:first-child{
	color:#000;
	font-size:14px;
}
.stMainTwo li:first-child a{
	padding:12px 0px;
}
.stMainTwo li a{
	float: left;
	width:49.5%;
	padding:10px 0px;
	display: block;
	text-align: center;
	border-right: 1px solid #dceada;
}
.stMainTwo li a:last-child{
	border-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/public-view/SeedDetails.vue